import React from "react";
import EntityDropdown from "../../../component/EntityDropdown";

export default function EntityField({ field, value, onChange, item = {} }) {
  const handle = o => {
    // isMulti: keep the selected option OBJECTS so EntityDropdown can render their labels
    // on re-render (mapping to bare ids makes its isMulti formatValue produce undefined
    // entries on the next pick). saveItem normalizes objects -> ids before POST/PATCH.
    if (field.isMulti) onChange(field.name, o || []);
    else onChange(field.name, o ? (o.id ?? o.value) : null);
  };
  // county scope (only applied by EntityDropdown for point/points entities)
  const county = field.scopeBy ? item[field.scopeBy] : undefined;
  return (
    <div className="mp-form-group">
      <label className="mp-form-label">{field._label}{field.required && " *"}</label>
      <EntityDropdown
        entity={field.entity}
        value={value}
        isMulti={!!field.isMulti}
        county={county}
        // Create/edit pickers offer ACTIVE related objects only (deactivated ones can't be
        // saved). A descriptor can override via field.query if it ever needs the full set.
        extraQuery={{ active: true, ...(field.query || {}) }}
        placeholder={field.placeholder}
        onChange={handle}
      />
    </div>
  );
}
